/**
 * Product Card Image Slider — Victoria Ariela / Dawn Theme
 * jQuery + Slick approach
 * Upload to: assets/product-card-slider.js
 */

(function ($) {
  'use strict';

  var peekDone = false;

  function doPeek($slider) {
    if (peekDone) return;
    peekDone = true;

    setTimeout(function () {
      var $track = $slider.find('.slick-track');
      var $cardMedia = $slider.closest('.card__media');
      var slideWidth = $slider.find('.slick-slide').first().width();
      var peekPx = slideWidth * 0.35;

      var currentTransform = $track.css('transform');
      var matrix = currentTransform.match(/matrix.*\((.+)\)/);
      var currentX = matrix ? parseFloat(matrix[1].split(', ')[4]) : 0;

      $slider.slick('slickSetOption', 'draggable', false);
      $slider.slick('slickSetOption', 'swipe', false);
      $slider.slick('slickSetOption', 'touchMove', false);

      $cardMedia.css('overflow', 'visible');

      $track.css({
        transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        transform: 'translateX(' + (currentX - peekPx) + 'px)'
      });

      setTimeout(function () {
        $track.css({
          transition: 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          transform: 'translateX(' + currentX + 'px)'
        });

        setTimeout(function () {
          $track.css({ transition: '', transform: '' });
          $cardMedia.css('overflow', 'hidden');
          $slider.slick('slickSetOption', 'draggable', true);
          $slider.slick('slickSetOption', 'swipe', true);
          $slider.slick('slickSetOption', 'touchMove', true);
          $slider.slick('slickGoTo', 0, true);
        }, 460);
      }, 700);
    }, 900);
  }

  function initSliders() {
    $('.product-card-slider:not(.slick-initialized)').each(function () {
      var $slider = $(this);
      var $cardWrapper = $slider.closest('.card-wrapper');
      var userHasInteracted = false;

      // Multi-method touch detection — covers Chrome Android
      var isTouchDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches
        || ('ontouchstart' in window)
        || (navigator.maxTouchPoints > 0);

      // Skip if not painted yet — Chrome Android fix
      if ($slider.width() === 0) return;

      $slider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        swipe: true,
        swipeToSlide: true,
        touchThreshold: 10,
        responsive: [
          {
            breakpoint: 750,
            settings: { arrows: true, dots: true }
          }
        ]
      });

      // Peek — mobile only, first slider only
      if (isTouchDevice && !peekDone) {
        doPeek($slider);
      }

      // Hover 2nd image — desktop only
      if (!isTouchDevice) {
        $cardWrapper.on('mouseenter', function () {
          if (!userHasInteracted) $slider.slick('slickGoTo', 1, true);
        });
        $cardWrapper.on('mouseleave', function () {
          if (!userHasInteracted) $slider.slick('slickGoTo', 0, true);
        });
      }

      $slider.on('swipe', function () {
        userHasInteracted = true;
        $slider.data('swiped', true);
      });
      $slider.on('click', '.slick-prev, .slick-next, .slick-dots button', function (e) {
        e.preventDefault();
        e.stopPropagation();
        userHasInteracted = true;
      });

      // Block navigation on swipe, allow normal tap through to anchor
      $slider.on('click', function (e) {
        if ($slider.data('swiped')) {
          e.preventDefault();
          e.stopPropagation();
          $slider.data('swiped', false);
        }
      });
    });
  }

  $(document).ready(initSliders);
  $(window).on('load', initSliders);

  document.addEventListener('shopify:section:load', initSliders);
  document.addEventListener('theme:products:updated', initSliders);

})(jQuery);
